import "./Home.module.css";
import MainNavigation from "@/reusable_sections/Header";
import GlobalLegalAuthority from "./sections/GlobalLegalAuthority";
import AboutCredentials from "./sections/AboutCredentials";
import ServicesGrid from "./sections/ServicesGrid";
import ClientSuccessStories from "./sections/ClientSuccessStories";
import LegalInsightsUpdates from "./sections/LegalInsightsUpdates";
import SecureYourConsultation from "./sections/SecureYourConsultation";
import FooterInformation from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <MainNavigation />
      <GlobalLegalAuthority />
      <AboutCredentials />
      <ServicesGrid />
      <ClientSuccessStories />
      <LegalInsightsUpdates />
      <SecureYourConsultation />
      <FooterInformation />
    </div>;
}